import { GET_ADDRATECARD_REQUESTED, GET_BASE_FUEL_REQUESTED, GET_RATECARD_REQUESTED } from "resources/actionTypes"

export function getRateCard(data) {
  return {
    type: GET_RATECARD_REQUESTED,
    payload: data
  };
}

export function postRateCard(userAddRateCard) {
  const data = {
    userAddRateCard: userAddRateCard,
  }
  return {
    type: GET_ADDRATECARD_REQUESTED,
    payload: data
  }
}

export function getBaseFuel(data) {
  return {
    type: GET_BASE_FUEL_REQUESTED,
    payload: data
  };
}
